import { jsx as p } from "react/jsx-runtime";
import d from "../../ui-kit/theme-button.mjs";
import { offerDefaultErrors as b } from "../../pages/checkout/constants/default-errors.mjs";
import { buyOffer as y } from "../../pages/checkout/api/index.mjs";
import { BadRequest as w } from "@systemeio/util";
import { useStore as h } from "../../store/index.mjs";
import { twJoin as D } from "tailwind-merge";
function v({
  isFetching: e,
  buttonTitle: n,
  setErrors: i,
  setIsFetching: o,
  preSubmit: a,
  handleBadRequest: f,
  hasErrors: m,
  buttonDisabled: s
}) {
  const { locale: c } = h(), u = async (l) => {
    l.preventDefault();
    try {
      o(!0), i(b);
      const t = a();
      if (!t) return;
      const { redirect: r } = await y(t, c);
      r && (window.location.href = r);
    } catch (t) {
      if (t instanceof w)
        f(t);
      else
        throw t;
    } finally {
      o(!1);
    }
  };
  return /* @__PURE__ */ p(
    d,
    {
      disabled: s,
      className: D("main-transition-colors", m && "bg-danger focus:bg-danger"),
      onClick: u,
      isFetching: e,
      type: "submit",
      children: n
    }
  );
}
export {
  v as DefaultPaymentButton
};
